


import Vue from 'vue';
import $ from 'jquery';
import i18n, {availableLocales, localizedRoute} from '../../../i18n/i18n.config'
import {RouteName} from "@/router";
import {Location} from "vue-router";

export default Vue.extend({
    data: () => ({
        i18n
    }),
    mounted(): void {
        $('.menu__links .navigation a').on('click', closeBurgerMenu);
        $('.menu__burger').one('click', openBurgerMenu);
        $('.menu__backdrop').on('click', closeBurgerMenu);

        function openBurgerMenu() {
            const $el = $('.menu__burger');
            $el.parent().addClass('menu--open');
            $el.one('click', () => closeBurgerMenu());
        }

        function closeBurgerMenu() {
            const $el = $('.menu__burger');
            $el.parent().removeClass('menu--open');
            $el.one('click', () => openBurgerMenu());
        }
    },
    computed: {
        currentLocale(): string {
            return this.i18n.locale;
        },
        homeRoute(): Location {
            return localizedRoute(RouteName.home);
        },
        contactRoute(): Location {
            return localizedRoute(RouteName.contact);
        },
        offerRoute(): Location {
            return localizedRoute(RouteName.offerList);
        },
        toggledLocaleId(): string {
            const currentIndex = availableLocales.indexOf(this.currentLocale);
            return availableLocales[(currentIndex + 1) % availableLocales.length];
        }
    },
    methods: {
        setLocale(localeId: string) {
            this.i18n.locale = localeId;
        },
        setToggledLocale() {
            this.setLocale(this.toggledLocaleId);
        },
        routeForLocale(localeId: string): Location {
            return {
                name: this.$route.name,
                hash: this.$route.hash,
                query: this.$route.query,
                params: {...this.$route.params, locale: localeId}
            };
        },
        routeForToggledLocale(): Location {
            return this.routeForLocale(this.toggledLocaleId);
        },
        isLocaleActive(localeId: string) {
            return this.i18n.locale === localeId;
        }
    }
});
